import React, { FC, useContext, useEffect } from 'react';

import { Button, H3, NumberInput, Tooltip } from '@smartshell/ui-kit';
import { Controller } from 'react-hook-form';

import { LocalizationContext } from 'localization';

import { getRandomNumber } from '../../../utils';
import s from './FormComponents.module.scss';
import { IFormComponentsProps } from './interfaces';

export const Clients: FC<IFormComponentsProps> = ({
  setOpenClientModal,
  chosenItems,
  setChosenItems,
  control,
  promoOrPromoCampaign,
  trigger,
  clearErrors,
  setValue,
}) => {
  const { t } = useContext(LocalizationContext);

  const hasClients = chosenItems?.some((item) => item.type === 'client');

  useEffect(() => {
    if (hasClients && promoOrPromoCampaign === 'promo') {
      clearErrors && clearErrors('amount');
      trigger && trigger();
      setValue('amount', 1);
    }
  }, [chosenItems?.length, clearErrors, trigger]);

  return (
    <div className={s.frame}>
      <div className={s.position_top}>
        <div className={s.header}>
          <div className={s.title_block}>
            <H3>{t('clients')}</H3>
          </div>
          <span className={s.text}>{t('promo.client.text')}</span>
        </div>

        <Button
          variant="secondary"
          iconName="CirclePlusIcon"
          className={s.position_add}
          onClick={() => setOpenClientModal && setOpenClientModal(true)}
        >
          {t('choose')}
        </Button>
      </div>

      {Boolean(chosenItems?.length) && (
        <div className={s.items}>
          {chosenItems?.map((item) => (
            <div key={`${item.type}-${item.id}`} className={s.item}>
              <span className={s.item_text}>{item.title}</span>
              <Button
                onClick={() =>
                  setChosenItems &&
                  setChosenItems((prev) =>
                    prev.filter((pos) => pos.id !== item.id)
                  )
                }
                iconName="CloseIcon"
                onlyIcon
                className={s.button}
              />
            </div>
          ))}
        </div>
      )}
      {promoOrPromoCampaign === 'promo' && (
        <Controller
          render={({ field: { name, ...field }, fieldState: { error } }) => (
            <NumberInput
              {...field}
              title={t('promo.limit.placeholder')}
              name={`${name}-${getRandomNumber()}`}
              error={!hasClients ? error?.message : undefined}
              bordered
              disabled={hasClients}
              rightContent={
                hasClients ? (
                  <Tooltip content={t('promo.client.input.tooltip')} />
                ) : undefined
              }
            />
          )}
          name="amount"
          control={control}
          rules={
            !hasClients
              ? {
                  required: t('errors.required'),
                  min: {
                    value: 1,
                    message: t('errors.min', 1),
                  },
                  max: {
                    value: 1000,
                    message: t('errors.max', 1000),
                  },
                }
              : undefined
          }
        />
      )}
    </div>
  );
};
